import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';
import MultiSelectInput from '@/components/form/MultiSelectInput.tsx';
import { NestedObjectListFieldDefinitionDto } from '@/components/table/_fieldDefinitions/nestedObjectList/NestedObjectListFieldDefinitionDto.ts';
import Option from '@/components/form/types/Option.ts';

export const NestedObjectListFilterInputs = ({
  form,
  index,
  fieldDef,
}: FilterInputProps) => {
  let options: Option[] = [];
  if (fieldDef) {
    const nestedListField = fieldDef as NestedObjectListFieldDefinitionDto;
    options =
      nestedListField.options?.map((o) => ({
        value: o.id,
        label: o.name ?? o.label ?? o.id,
      })) ?? [];
  }
  return (
    <MultiSelectInput
      controlSize="toolbar"
      placeholder="Wpisz wartość"
      fieldPath={`filters.${index}.value`}
      control={form.control}
      options={options}
    />
  );
};
